const parseAttribute = (raw) => {
  if (typeof raw === 'string') {
    try { return JSON.parse(raw) } catch (error) { return null }
  }
  return raw && typeof raw === 'object' ? raw : null
}

export const isJoinEnabledBySetting = (setting, slideAttributes) => {
  if (!setting?.enableAudienceJoinPresentation) return false
  const gate = setting.audienceJoinRequiresConfig
  if (!gate?.attribute || !gate?.field) return true
  return Boolean(parseAttribute(slideAttributes?.[gate.attribute])?.[gate.field])
}

export const isPluginJoinEnabled = (customSetting, builtInSetting, slideAttributes) => isJoinEnabledBySetting(customSetting, slideAttributes) || isJoinEnabledBySetting(builtInSetting, slideAttributes)
